export enum ConditionComparisonType {
  None = 'None',
  Equals = 'Equals',
  NotEquals = 'NotEquals',
  GreaterThan = 'GreaterThan',
  GreaterThanEquals = 'GreaterThanEquals',
  LessThan = 'LessThan',
  LessThanEquals = 'LessThanEquals',
  Empty = 'Empty',
  NotEmpty = 'NotEmpty',
}
